import * as React from 'react';

const AlertErrorIcon = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM12 20C14.1 20 16.2 19.2 17.7 17.7C19.2 16.2 20 14.1 20 12C20 9.9 19.2 7.8 17.7 6.3C16.2 4.8 14.1 4 12 4C9.9 4 7.8 4.8 6.3 6.3C4.8 7.8 4 9.9 4 12C4 14.1 4.8 16.2 6.3 17.7C7.8 19.2 9.9 20 12 20ZM14.3 8.3C14.7 7.9 15.3 7.9 15.7 8.3C16.1 8.7 16.1 9.3 15.7 9.7L13.4 12L15.7 14.3C16.1 14.7 16.1 15.3 15.7 15.7C15.3 16.1 14.7 16.1 14.3 15.7L12 13.4L9.7 15.7C9.3 16.1 8.7 16.1 8.3 15.7C7.9 15.3 7.9 14.7 8.3 14.3L10.6 12L8.3 9.7C7.9 9.3 7.9 8.7 8.3 8.3C8.7 7.9 9.3 7.9 9.7 8.3L12 10.6L14.3 8.3Z"
      fill={color}
    />
  </svg>
);
export default AlertErrorIcon;
